(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('abnormal-alert', {
            parent: 'entity',
            url: '/abnormal-alert',
            data: {
                authorities: [],
                pageTitle: 'AbnormalAlerts'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/abnormal-alert/list/abnormal-alert.html',
                    controller: 'AbnormalAlertController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY, access);
            }]
        })
    }
})();
